import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

@Component({
    selector: "app-chase-failure-dialog",
    templateUrl: "./chase-failure-dialog.component.html",
    styleUrls: ["./chase-failure-dialog.component.scss"],
})
export class ChaseFailureDialogComponent implements OnInit
{


    constructor(
        public dialogRef: MatDialogRef<ChaseFailureDialogComponent>,
        public dialog: MatDialog,
    ) { }

    ngOnInit(): void
    {
    }

    public handleDoneClick(): void
    {
        this.dialogRef.close();
    }

}

